import {
  BASE_PERMISSIONS,
  BaseInquiryStatus,
  BaseDateService,
  BASE_DATE_SERVICE_FORMAT,
  BASE_ROLES,
  BaseApplicationSectionsInterface,
} from 'base';

export const APPLICATION_SECTIONS_MEDICAL: BaseApplicationSectionsInterface[] = [
  {
    id: 0,
    icon: 'fa-solid fa-fw fa-house',
    title: 'dashboard',
    url: '/dashboard',
    featurePermissionKeys: [BASE_PERMISSIONS.FEATURE_VIEW_DASHBOARD],
    roleKeys: [],
  },
  {
    id: 1,
    icon: 'fa-solid fa-fw fa-user-plus',
    title: 'inquiries',
    url: '/inquiries/list',
    queryParams: { page: 1, status: `${BaseInquiryStatus.unpublished},${BaseInquiryStatus.published}` },
    featurePermissionKeys: [BASE_PERMISSIONS.FEATURE_ADMIN_INQUIRY],
    roleKeys: [],
  },
  {
    id: 2,
    icon: 'fa-solid fa-fw fa-people-group',
    title: 'inquiry.plural',
    url: '/offers/list',
    featurePermissionKeys: [],
    roleKeys: [BASE_ROLES.CUSTOMER_WORK_COUNCIL],
  },
  {
    id: 3,
    icon: 'fa-solid fa-fw fa-bullseye',
    title: 'externalEmployees.title',
    url: '/external-employees/list',
    queryParams: { page: 1, status: 'planned,active' },
    featurePermissionKeys: [BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS],
    roleKeys: [BASE_ROLES.CUSTOMER_WORK_COUNCIL],
  },
  {
    id: 4,
    icon: 'fa-solid fa-rectangle-list',
    title: 'timeRecordings.page',
    url: '/time-recordings/list',
    queryParams: {
      page: 1,
      period: `${BaseDateService.format(
        BaseDateService.getDateDaysAgo(7),
        BASE_DATE_SERVICE_FORMAT
      )},${BaseDateService.format(new Date(), BASE_DATE_SERVICE_FORMAT)}`,
    },
    featurePermissionKeys: [
      BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS,
      BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENT_DATES,
    ],
    roleKeys: [],
  },
  {
    id: 5,
    icon: 'fa-solid fa-handshake',
    title: 'provider',
    url: '/service-provider',
    queryParams: { page: 1 },
    featurePermissionKeys: [],
    roleKeys: [],
  },
];
